import { DashboardReportTypes } from 'constants/layout'
import { get } from 'helpers/api_helper'
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"

const TopViews = () => {
    const [type, setType] = useState(DashboardReportTypes[0])
    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)
  
    useEffect(async() => {
      setLoading(true)
      setData(null)
      try {
        const res = await get(`api/org/topclients/${type.value}`)
        if (res && res.status == 200) {
          setData(res.response)
        }
      } catch (err) {
        console.error("TopViews error:", err)
      } finally {
        setLoading(false)
      }
    }, [type])

    const orders = data?.orders || []
    const invoices = data?.invoice || []
    const rowCount = Math.max(orders.length, invoices.length, 5)

    return (
        <Row>
            <Col md="12">
                <Card className="shadow-sm border-0">
                    <CardBody>
                        <Row className="mb-3 align-items-center">
                            <Col>
                                <h4 className="card-title mb-0">{type.title} Clients</h4>
                            </Col>
                            <Col md="5">
                                <select onChange={(e) => setType(JSON.parse(e.target.value))} className="form-select form-control" name="fmytd">
                                    {
                                        DashboardReportTypes.map((v,i) => <option value={JSON.stringify(v)} key={`TPD_${i}${v.value}`}>{v.title}</option>)
                                    }
                                </select>
                            </Col>
                        </Row>
                        <div className="table-responsive">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: '40px' }}>#</th>
                                        <th>Top by Orders</th>
                                        <th>Top by Invoiced Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading || !data ? (
                                        Array.from({ length: 5 }).map((_, idx) => (
                                            <tr key={`skel_tv_${idx}`}>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '16px', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '70%', height: '14px', marginBottom: 0 }} /></td>
                                                <td><div className="shimmer-box shimmer-text" style={{ width: '65%', height: '14px', marginBottom: 0 }} /></td>
                                            </tr>
                                        ))
                                    ) : orders.length === 0 && invoices.length === 0 ? (
                                        <tr>
                                            <td colSpan="3" className="text-center py-3 text-muted">
                                                No client records found.
                                            </td>
                                        </tr>
                                    ) : (
                                        Array.from({ length: rowCount }).map((_, index) => {
                                            const order = orders[index]
                                            const invoice = invoices[index]
                                            return (
                                                <tr key={`TCL_${index}`} className="fade-in-content">
                                                    <td className="text-muted">{index + 1}</td>
                                                    <td>
                                                        {order ? (
                                                            <div className="d-flex align-items-center justify-content-between pe-2">
                                                                <span className="text-truncate fw-medium text-dark">{order.clientname}</span>
                                                                <span className="badge bg-primary bg-soft text-primary font-size-11">{parseFloat(order.orders).toFixed(0)} orders</span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted font-size-12">---</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {invoice ? (
                                                            <div className="d-flex align-items-center justify-content-between pe-2">
                                                                <span className="text-truncate fw-medium text-dark">{invoice.clientname}</span>
                                                                <span className="text-success fw-bold font-size-12">₹{parseFloat(invoice.amount).toFixed(2)}</span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-muted font-size-12">---</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    )
}

export default TopViews;